exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-content[data-v-1d371b27]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:center;align-items:center}.form[data-v-1d371b27]{width:100%}.form__element[data-v-1d371b27]{margin:var(--spacer-base) 0}.form__submit[data-v-1d371b27]{margin:var(--spacer-xl) 0 0 0}.action-button[data-v-1d371b27]{margin:var(--spacer-xl) 0}\n", ""]);

// exports
